import LearningIndex from '@components/LearningIndex';
import { createStaticPropsFetcher } from '@lib/fetch/getStaticProps';
import type { GetStaticProps, NextPage } from 'next';

const LearningIndexView: NextPage = () => <LearningIndex />;

export const getStaticProps: GetStaticProps = createStaticPropsFetcher('learningIndex');

export default LearningIndexView;
